export default {
    items: [
        {
            text: 'Please Add Each Owner',
            type: 'data-table',
            name: 'owner-information',
            props: {
                headers: [
                    {
                        text: 'Name',
                        value: 'full-name'
                    },
                    {
                        text: 'Current Compensation',
                        value: 'compensation',
                        format: 'dollars'
                    },
                    {
                        text: 'Preferred Contact Method',
                        value: 'preferred-contact',
                        useDisplay: true
                    }
                ],
                newItemLabel: 'Add New Owner',
                noDataLabel: 'Please Add an Owner'
            }
        },
        {
            text: 'How many hours are you currently working per week (estimated)?',
            type: 'text-field',
            name: 'owner-weekly-hours',
            props: {
                label: 'Estimated Weekly Hours',
                format: 'number'
            }
        },
        {
            text: 'When do you want to start reducing your workload?',
            type: 'datepicker',
            name: 'owner-start-time',
            props: {}
        },
        {
            text: 'When do you want to retire?',
            type: 'datepicker',
            name: 'owner-retire-time',
            props: {}
        },
        {
            text: 'What are you biggest concerns about this process?',
            type: 'textarea',
            name: 'owner-concerns',
            props: {}
        },
        {
            text: 'Please rate the following transition goals from highest to lowest priority',
            subItems: [
                {
                    text: 'Maximize Total value',
                    type: 'slider',
                    name: 'owner-goal-total-value',
                    props: {
                        labels: [
                            'Lowest Priority',
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            'Highest Priority'
                        ]
                    }
                },
                {
                    text: 'Maximum flexibility for owner',
                    type: 'slider',
                    name: 'owner-goal-flexibility',
                    props: {
                        labels: [
                            'Lowest Priority',
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            'Highest Priority'
                        ]
                    }
                },
                {
                    text: 'Maintain control until you are 100% retired',
                    type: 'slider',
                    name: 'owner-goal-control',
                    props: {
                        labels: [
                            'Lowest Priority',
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            'Highest Priority'
                        ]
                    }
                },
                {
                    text: 'Minimize risk/exposure (e.g., shorter financing, less contingencies)',
                    type: 'slider',
                    name: 'owner-goal-minimize-risk',
                    props: {
                        labels: [
                            'Lowest Priority',
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            'Highest Priority'
                        ]
                    }
                },
                {
                    text: 'Maximize the after-tax result',
                    type: 'slider',
                    name: 'owner-goal-tax',
                    props: {
                        labels: [
                            'Lowest Priority',
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            'Highest Priority'
                        ]
                    }
                },
                {
                    text: 'Share ownership to retain talent',
                    type: 'slider',
                    name: 'owner-goal-talent',
                    props: {
                        labels: [
                            'Lowest Priority',
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            'Highest Priority'
                        ]
                    }
                }
            ]
        }
    ]
};


// WEBPACK FOOTER //
// ./src/components/succession-archive/valuation-data/owner.js